import ModalRequest from '../../components/ModalRequest'
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { Input } from '../../components/StyleComponent'
import { useCallback, useEffect, useState } from 'react'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
import dayjs from 'dayjs'
import ModalResetPw from '../UserManagement/ModalResetPw'
import { useAuth } from '../../hook/useAuth'
import { DatePicker } from '@mui/x-date-pickers'

export default function EditUser({
    open,
    setOpen,
    keyName,
    handleAlert,
    getUserByKey,
    row,
}) {
    const [role, setRole] = useState([])
    const [loading, setLoading] = useState(false)
    const { handleSubmit, setValue, watch } = useForm()
    const [resetPw, setResetPw] = useState(false)
    const [data, setData] = useState('')
    const { auth } = useAuth()
    const myLevel = auth?.role_level || 0

    const getUser = useCallback(async () => {
        try {
            if (!row.user_id) return
            const res = await axiosInstance.get(
                `${urlConfig.user}/user_id/${row.user_id}`,
            )

            setData(res.data.message)
        } catch (err) {
            console.error(err)
        } finally {
        }
    }, [row])

    useEffect(() => {
        getUser()
    }, [row, getUser])

    const onSubmit = async (data) => {
        if (data.password !== data.confirmPassword) {
            alert('Passwords do not match!')
            return
        }
        const body = {
            keyName: keyName,
            status: !!data.status ? 'Active' : 'Inactive',
            first_name: data.first_name,
            last_name: data.last_name,
            phone_number: data.phone_number,
            group: data.group,
            role_id: data.role_id,
            expire_date: data.expire_date,
        }
        if (!data.phone_number) {
            delete body.phone_number
        }
        delete body.set_new_pwd

        try {
            setLoading(true)
            await axiosInstance.put(`${urlConfig.user}/${row.user_id}`, body)
            handleAlert('User updated successfully.', 'success')
            getUserByKey()
            setOpen(false)
        } catch (err) {
            handleAlert(
                `${err.response.data.message || 'No Internet'}`,
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (row) {
            Object.keys(row).forEach((key) => {
                if (key === 'expire_date') {
                    setValue(key, dayjs(row[key]))?.format('DD/MM/YYYY')
                } else {
                    setValue(key, row[key])
                }
            })
        }
    }, [row, setValue])

    const handleChange = (name, value) => {
        setValue(name, value)
    }

    const getRole = useCallback(async () => {
        if (!myLevel) return
        try {
            const res = await axiosInstance.get(urlConfig.role)
            if (!res.data.message[0]) return
            const filteredRoles = res.data?.message?.filter(
                (item) => item.level <= myLevel,
            )
            setRole(filteredRoles)
        } catch {}
    }, [])

    useEffect(() => {
        getRole()
    }, [getRole])

    return (
        <>
            <ModalResetPw
                isCancel={(data && data.set_new_pwd) || false}
                handleAlert={handleAlert}
                open={resetPw}
                setOpen={setResetPw}
                row={row}
                getUser={getUser}
                setResetPw={setResetPw}
            />

            <ModalRequest
                open={open}
                disabled={loading}
                setOpen={setOpen}
                title={`Edit User [${keyName}]`}
                onSubmit={handleSubmit(onSubmit)}
            >
                <Grid container spacing={2} p={2}>
                    <Grid item xs={12}>
                        <FormControl
                            fullWidth
                            size='small'
                            sx={{
                                height: '35px',
                            }}
                        >
                            <InputLabel id='demo-simple-select-label'>
                                Group
                            </InputLabel>
                            <Select
                                label='Group'
                                id='Role'
                                required
                                onChange={(e) => {
                                    handleChange('role_id', null)
                                    handleChange('group', e.target.value)
                                }}
                                defaultValue={''}
                                value={watch('group') || ''}
                            >
                                <MenuItem value={'User'}>User</MenuItem>
                                <MenuItem value={'Admin'}>Admin</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {watch('group') && (
                        <Grid item xs={12} md={12}>
                            <FormControl size='small' fullWidth>
                                <InputLabel>Role * </InputLabel>
                                <Select
                                    label='Role'
                                    required
                                    onChange={(e) =>
                                        handleChange('role_id', e.target.value)
                                    }
                                    value={watch('role_id') || ''}
                                    sx={{
                                        // height: '35px',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <MenuItem value=''>-</MenuItem>
                                    {role
                                        .filter(
                                            (item) =>
                                                item.group === watch('group'),
                                        )
                                        .map((item) => (
                                            <MenuItem
                                                key={item.role_id}
                                                value={item.role_id}
                                            >
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}

                    <Grid item xs={12} md={12}>
                        <DatePicker
                            name='expire_date'
                            label='Expire Date'
                            InputLabelProps={{ shrink: true }}
                            slotProps={{ textField: { size: 'small' } }}
                            format='DD/MM/YYYY'
                            value={watch('expire_date')}
                            onChange={(date) =>
                                setValue('expire_date', date ? date : '')
                            }
                            sx={{ width: '100%' }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input
                            label='First name'
                            defaultValue={watch('first_name') || ''}
                            required
                            name='first_name'
                            onChange={(e) =>
                                handleChange('first_name', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input
                            label='Last name'
                            defaultValue={watch('last_name') || ''}
                            required
                            name='last_name'
                            onChange={(e) =>
                                handleChange('last_name', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Input
                            label='Email'
                            defaultValue={watch('email') || ''}
                            type='email'
                            required
                            name='email'
                            onChange={(e) =>
                                handleChange('email', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Input
                            label='Phone number'
                            defaultValue={watch('phone_number') || ''}
                            name='phone_number'
                            onChange={(e) =>
                                handleChange('phone_number', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} align='right'>
                        <Box>
                            <label>Active</label>
                            <Switch
                                checked={
                                    (typeof watch('status') === 'string' &&
                                    watch('status') === 'Active'
                                        ? true
                                        : false) ||
                                    (typeof watch('status') === 'boolean' &&
                                        watch('status')) ||
                                    false
                                }
                                color='success'
                                onChange={(e, nv) => handleChange('status', nv)}
                            />
                        </Box>
                        <Grid item xs={12} align='right'>
                            <Box>
                                <label>Reset Password</label>
                                <Switch
                                    checked={
                                        data && data.set_new_pwd
                                            ? data.set_new_pwd
                                            : resetPw
                                    }
                                    color='success'
                                    onChange={(e, nv) =>
                                        data && data.set_new_pwd
                                            ? setResetPw(true)
                                            : setResetPw(nv)
                                    }
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </ModalRequest>
        </>
    )
}
